<script setup>
import { useChatStore } from '@/views/apps/chat/useChatStore'
import ChatApexChart from '@/views/apps/chat/charts/ChatApexChart.vue'
import { onMounted } from 'vue'

const chatStore=useChatStore()

definePage({
  meta: {
    action: 'read',
    subject: 'bots',
    useBotNav: true,
    useChatNav: true,
  },
})

onMounted(async()=>{
  console.log('chaning isMaximizeMode to true')
  chatStore.isMaximizeMode=true
})
</script>

<template>
  <ChatApexChart 
    v-if="chatStore.maximizedChartMessage!={} && chatStore.maximizedChartMessage && chatStore.maximizedChart!={} && chatStore.maximizedChart"
    :chat-message="chatStore.maximizedChartMessage"
    :chart-content="chatStore.maximizedChart"
    always-show-content
    class="w-100 px-0 mx-0"
  />
</template>
